import { graphqlPost } from "api/graphqlClient";
import { actions as latestEditsActions } from "components/Charts/LatestEdits/LatestEdits.reducer";
import NotificationService from "components/Notification/Notification.service";
import RestErrorNotification from "components/Notification/RestErrorNotification";
import { call, put, takeLatest } from "redux-saga/effects";

/**
 * Fetch latest edits
 * @param  {Object} promise
 * @param {params} graphql params
 * @return {Object} response
 */
export function* fetchLatestEdits({ promise, params }) {
    try {
        const response = yield graphqlPost(params);
        yield put({
            type: latestEditsActions.SUCCESSFUL_FETCH_LATEST_EDITS,
            response: response?.data?.resource_list?.resource_list,
        });

        if (promise) {
            yield call(promise.resolve, response?.data?.resource_list?.resource_list);
        }
    } catch (error) {
        yield put({
            type: latestEditsActions.FAILED_FETCH_LATEST_EDITS,
        });
        if (promise) {
            yield call(promise.reject, error?.response?.data || error);
        }
        NotificationService.error(
            <RestErrorNotification titleOverride="Sorry, couldn't get latest edits" error={error} />
        );
    }
}

/**
 * Register action to watcher
 */
export default [takeLatest(latestEditsActions.START_FETCH_LATEST_EDITS, fetchLatestEdits)];
